import { jsx as c } from "react/jsx-runtime";
import { useCallback as p } from "react";
import { i as m } from "../../type-BFTbooL7.js";
import u from "../SearchMultiSelectInput/index.js";
import { d as f } from "../../common-CLw-EvUg.js";
function C(n) {
  const {
    name: e,
    options: t,
    keySelector: o,
    onChange: l,
    withSelectAll: r,
    ...i
  } = n, s = p(
    () => {
      if (m(t))
        return;
      const a = t.map(o);
      l(a, e);
    },
    [t, e, l, o]
  );
  return /* @__PURE__ */ c(
    u,
    {
      ...i,
      name: e,
      onChange: l,
      options: t,
      keySelector: o,
      sortFunction: f,
      searchOptions: t,
      onSelectAllButtonClick: r ? s : void 0,
      selectedOnTop: !1
    }
  );
}
export {
  C as default
};
